import { useEffect, type RefObject } from 'react';

import {
  COMPOSER_FOCUS_REQUESTED,
  localChatEventsBus,
} from '@/features/chat/chat.events';
import { getDraftId } from '@/features/chat/composer-draft-id';
import { NEW_CHAT_ID } from '@/utils/constants';

export const useScrollToComposer = (
  scrollRef: RefObject<HTMLElement | null>
) => {
  useEffect(() => {
    const subscription = localChatEventsBus.on(
      COMPOSER_FOCUS_REQUESTED,
      ({ data }) => {
        if (data.draftId !== getDraftId(NEW_CHAT_ID, null)) return;
        scrollRef.current?.scrollTo({ top: 0, behavior: 'smooth' });
      }
    );
    return () => subscription.unsubscribe();
  }, [scrollRef]);
};
